export default __webpack_public_path__ + "static/media/ncx-primary-logo-icon.7825bc87.svg";